import { useSpaceUnmute } from './use-space-unmute';

interface UseHotKeysParams {
    withSpaceUnmute?: boolean;
}

const DEFAULT_PARAMS: UseHotKeysParams = {
    withSpaceUnmute: true,
};

export function useHotKeys(params: UseHotKeysParams = {}) {
    const { withSpaceUnmute } = { ...DEFAULT_PARAMS, ...params };

    useSpaceUnmute(withSpaceUnmute);
}
